import { useEffect, useMemo } from 'react';
import {
  collectionSyncEventName,
  collectionSyncStorageKey,
  readCollectionChangePayload,
} from '../utils/collectionSync';

function normalizeKeys(keys) {
  return [...new Set((Array.isArray(keys) ? keys : [keys]).filter(Boolean))];
}

export function useCollectionSync(collectionKeys, onChange) {
  const keys = useMemo(() => normalizeKeys(collectionKeys), [collectionKeys]);

  useEffect(() => {
    if (keys.length === 0 || typeof onChange !== 'function') return undefined;

    const eventName = collectionSyncEventName();
    const storageKey = collectionSyncStorageKey();

    const matches = (payload) => {
      const collectionKey = payload?.collectionKey ?? payload?.key ?? null;
      return collectionKey && keys.includes(collectionKey);
    };

    const handleCustomEvent = (event) => {
      const payload = event?.detail ?? null;
      if (matches(payload)) onChange(payload);
    };

    const handleStorageEvent = (event) => {
      if (event?.key !== storageKey) return;
      const payload = readCollectionChangePayload(event.newValue);
      if (matches(payload)) onChange(payload);
    };

    window.addEventListener(eventName, handleCustomEvent);
    window.addEventListener('storage', handleStorageEvent);

    return () => {
      window.removeEventListener(eventName, handleCustomEvent);
      window.removeEventListener('storage', handleStorageEvent);
    };
  }, [keys, onChange]);
}
